import type { PostHog } from "@posthog/types";
import type { PostHogInterface } from "posthog-js";
import type { InjectionKey, Plugin } from "vue";
import { getClientConfig } from "ls/state/queries";
import posthogJs from "posthog-js";
import { inject } from "vue";
import { usePostHogIdentifyCurrentUser } from "./usePostHogIdentifyCurrentUser";

declare global {
  interface Window {
    posthog?: PostHogInterface;
  }
}

const postHogKey = Symbol(import.meta.env.DEV ? "posthog" : "") as InjectionKey<PostHog>;

function getPostHogConfig() {
  const config = getClientConfig();
  if (!config) return undefined;
  if (!config.PostHogApiKey) return undefined;

  return {
    apiKey: config.PostHogApiKey,
    apiHost: config.PostHogApiHost ?? "https://us.i.posthog.com",
  };
}

export const posthog: Plugin = {
  install(app) {
    const config = getPostHogConfig();

    if (config) {
      posthogJs.init(config.apiKey, {
        api_host: config.apiHost,
        defaults: "2025-05-24",
        loaded(posthog_instance) {
          window.posthog = posthog_instance;
        },
        capture_pageview: false,
      });
    }

    app.provide(postHogKey, posthogJs);

    app.runWithContext(() => {
      usePostHogIdentifyCurrentUser();
    });
  },
};

export function usePostHog() {
  return inject(postHogKey)!;
}
